/******************************************************************************
Chemical Reducer: Handles all interactions & state changes with the chemical
component.
Hawaiian Macadamia Nut Services
Alexander Self
7/23/19
*******************************************************************************/
import { calculatePercentage } from '../cult_utils';
import { ADD_SOLUTION, EDIT_SOLUTION, DELETE_SOLUTION, SELECT_SOLUTION_TO_EDIT,
  SET_TOTAL_GALLONS, PREPARE_DATA, CREATE_CHEMICAL_APPLICATION, FETCH_CHEMICAL_APPLICATIONS,
  SELECT_FIELD, DELETE_CHEMICAL_APPLICATION, SELECT_FIELD_FOR_EDIT, SELECT_CHEMICAL_APPLICATION_TO_EDIT,
  EDIT_CHEMICAL_APPLICATION, SELECT_APPLICATION_TO_VIEW, CLEAR_FORM, ERROR } from '../actions/types';
import moment from 'moment';
let initState = {
  chemicalApplications: {
    all: [],
    displaying: []
  },
  view: {
    app: {},
    previousApplications: []
  },
  app: {
    editingApplication: false,
    solutions: [], // Solutions used
    selectedField: {},
    chemAppId: null, // Application ID if editing
    isEditing: false,
    editSolution: {}, // Solution being edited
    totalGallons: 0, // Used to calculate percentage of chem used
    application: {}, // Application to submit
    previousApplications: [], // Previous applications within the same field, round
    deletedSolutions: [] // Solutions deleted during the app edit process(Need to delete serverside)
  }
};

export default function ChemicalApplicationReducer(state=initState, action) {
  switch (action.type) {
    case ADD_SOLUTION:
      return { ...state,
        app: { ...state.app,
          solutions: state.app.solutions.concat(action.payload)
        }
      };
    case SELECT_SOLUTION_TO_EDIT:
      return { ...state,
        app: { ...state.app,
          isEditing: true,
          editSolution: action.payload
        }
      }
    case EDIT_SOLUTION:
      return { ...state,
        app: { ...state.app,
          solutions: state.app.solutions.filter((s) => s.id !== state.app.editSolution.id).concat(action.payload),
          isEditing: false,
          editSolution: {}
        }
      }
    case DELETE_SOLUTION:
      return { ...state,
        app: { ...state.app,
          solutions: state.app.solutions.filter((s) => s.id !== action.payload.id),
          isEditing: false,
          editSolution: {},
          deletedSolutions: state.app.deletedSolutions.concat(action.payload.id)
        }
      }
    case SELECT_FIELD:
      return { ...state,
        app: { ...state.app,
          selectedField: action.payload
        }
      }
    case SELECT_FIELD_FOR_EDIT:
      return { ...state,
        app: { ...state.app,
          selectedField: action.payload
        }
      }
    case SET_TOTAL_GALLONS:
    // Yeah, don't do this. Fix this later 8.6.19
      let solutions = state.app.solutions;
      if (state.app.solutions.length > 0) {
        solutions = state.app.solutions.map((s) => {
          return { ...s,
            percentageUsed: calculatePercentage({ quantity: s.chemDosage1, unit: s.chemDosage2, totalGallons: action.payload })
          }
        })
      }
      return { ...state,
        app: { ...state.app,
          totalGallons: action.payload,
          solutions
        }
      }
    case PREPARE_DATA:
      return { ...state,
        app: { ...state.app,
          application: action.payload,
          previousApplications: action.previousApplications
        }
      }
    case CREATE_CHEMICAL_APPLICATION:
      return { ...state,
        chemicalApplications: {
          all: state.chemicalApplications.all.concat(action.payload),
          displaying: state.chemicalApplications.displaying.concat(action.payload).sort(sortByDateField)
        },
        app: initState.app
      }
    case EDIT_CHEMICAL_APPLICATION:
      return { ...state,
        chemicalApplications: {
          all: state.chemicalApplications.all.filter((c) => c.chemAppId !== action.payload.chemAppId).concat(action.payload).sort(sortByDateField),
          displaying: state.chemicalApplications.displaying.filter((c) => c.chemAppId !== action.payload.chemAppId).concat(action.payload).sort(sortByDateField)
        },
        app: initState.app
      }
    case FETCH_CHEMICAL_APPLICATIONS:
      return { ...state,
        chemicalApplications: {
          all: action.payload,
          displaying: action.payload.sort(sortByDateField)
        }
      }
    case DELETE_CHEMICAL_APPLICATION:
      return { ...state,
        chemicalApplications: {
          all: state.chemicalApplications.all.filter((c) => c.id !== Number(action.payload)),
          displaying: state.chemicalApplications.displaying.filter((c) => c.id !== Number(action.payload)),
          previousApplications: []
        }
      }
    case SELECT_CHEMICAL_APPLICATION_TO_EDIT:
      return { ...state,
        app: { ...state.app,
          editingApplication: true,
          totalGallons: action.payload.measurement,
          solutions: action.payload.solutions,
          chemAppId: action.payload.chemAppId,
          selectedField: action.field,
          application: {},
          isEditing: false,
          editSolution: {}, // Solution being edited
          previousApplications: [], // Previous applications within the same field, round
          deletedSolutions: [] // Solutions deleted during the app edit process(Need to delete serverside)
        }
      }
    case SELECT_APPLICATION_TO_VIEW:
      return { ...state,
        view: {
          app: action.payload,
          previousApplications: action.previousApplications
        }
      }
    case CLEAR_FORM:
      return { ...state,
        app: initState.app
      }
    case ERROR:
      return state;
    default:
      return state;
  }
}



function sortByDateField(a,b) {
  if ((moment(a.date).format('YYYY-MM-DD')) < (moment(b.date).format('YYYY-MM-DD'))) return 1;
  else if ((moment(a.date).format('YYYY-MM-DD')) > (moment(b.date).format('YYYY-MM-DD'))) return -1;
  else if ((moment(a.date).format('YYYY-MM-DD')) === (moment(b.date).format('YYYY-MM-DD'))) {
    if (a.fieldId < b.fieldId) return -1;
    else if (a.fieldId > b.fieldId) return 1;
    return 0;
  }
  return 0;
}



















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/chem_app_reducer.js